// extracted by mini-css-extract-plugin
export default {"dialog":"MakePaymentDialog_dialog__aYXr9","error":"MakePaymentDialog_error__WeLjX","formButton":"MakePaymentDialog_formButton__nymF3"};